import { resolveWorkspaceFilePath } from '../../workspace-files.js';
import { extractDiffPath, readOptionalTextField } from './paths-and-text.js';

export type FileDiffRecord = { path: string; oldText: string; newText: string };

export function pushDiffIfComplete(o: Record<string, unknown>, sessionParentPath: string, out: FileDiffRecord[]): void {
  const t = o.type;
  if (typeof t !== 'string' || t.toLowerCase() !== 'diff') return;
  const rawPath = extractDiffPath(o);
  if (!rawPath) return;
  const resolved = resolveWorkspaceFilePath(sessionParentPath, rawPath);
  if (!resolved) return;
  const oldText = readOptionalTextField(o.oldText ?? o.old_text ?? o.before ?? o.oldContent);
  const newText = readOptionalTextField(o.newText ?? o.new_text ?? o.after ?? o.newContent);
  out.push({ path: resolved.display, oldText, newText });
}
